import {ADD_ACTIVITIES, SET_ACTIVITIES_END, CLEAR_ACTIVITIES,ADD_ACTIVITY } from 'actions/types';

export default (state = {list:[], indexed:{},nextDate:null, end:false,challengeReaction:null,challengeReportReason:null}, action) => {
    switch(action.type) {
        case ADD_ACTIVITIES: 
            return {...state, 
                list:state.list.concat(action.activities.map(a => a.id)),
                indexed: action.activities.reduce((m,a)=>{m[a.id]=a;return m;},{...state.indexed}), 
                challengeReaction : action.challengeReaction,
                challengeReportReason : action.challengeReportReason,
                nextDate:action.nextDate};
        case SET_ACTIVITIES_END: 
            return {...state, end:true};
        case CLEAR_ACTIVITIES: 
            return {...state, list:[], indexed:{}, nextDate:null, end:false, challengeReaction:null, challengeReportReason:null};
        case ADD_ACTIVITY: 
            return {...state,
                    indexed: {...state.indexed, [action.activity.id]:action.activity}
                    };
        default:            
            return state;
    }
}

export const getActivity = (state, id) => state.indexed[id];
export const getActivities = state => state.list.map( id => state.indexed[id] );



// WEBPACK FOOTER //
// ./src/reducers/activities.js